<script setup lang="ts">
import useLocale from '../../../composables/useLocale';

type Props = {
  items: any[];
  id: string;
};
const props = defineProps<Props>();
type Emits = {
  (e: 'search', value: string): void;
  (e: 'update', value: string): void;
};
const emit = defineEmits<Emits>();
const { t } = useLocale();

const filterId = `search-input-${props.id}`;
const messageId = `message-${props.id}`;
</script>

<template>
  <v-autocomplete
    :id="filterId"
    :items="items"
    class="mx-auto mt-2 px-2"
    density="comfortable"
    rounded="md"
    item-title="label"
    variant="outlined"
    color="primary"
    menu-icon=""
    :placeholder="t('content_search.label_search_by_filters')"
    :aria-label="t('content_search.label_search_by_filters')"
    prepend-inner-icon="mdi-magnify"
    :no-data-text="t('content_search.no_data')"
    auto-select-first
    hide-details
    clearable
    :menu-props="{ zIndex: 10000 }"
    bg-color="surface-bright"
    @update:search="(value: string) => emit('search', value)"
    @update:modelValue="(value: string) => emit('update', value)"
  >
    <template #message="{ message }">
      <div :id="messageId">
        {{ message }}
      </div>
    </template>
  </v-autocomplete>
</template>

<style scoped lang="scss">
:deep(.v-field) {
  font-size: 0.9rem !important;
}
</style>
